import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import PdpSharedDetailAttributeLink from './helpers/PdpSharedDetailAttributeLink';

// helpers
import get from 'lodash.get';

function PdpSharedDetailPeriod({ item }) {
    return (
        <PdpSharedDetailAttributeLink
            item={item}
            dataTn="pdp-spec-period"
            attributes={get(item, 'attributes.period')}
        />
    );
}

PdpSharedDetailPeriod.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailPeriod, {
    item: graphql`
        fragment PdpSharedDetailPeriod_item on Item {
            ...PdpSharedDetailAttributeLink_item
            attributes {
                period {
                    ...PdpSharedDetailAttributeLink_attributes
                }
            }
        }
    `,
});
